module.exports = __webpack_public_path__ + "img/generic-background.66fc8bdf.png";